import React, { useEffect, useState } from 'react';
import {
  Box,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Select,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  VStack,
  HStack,
  Text,
  useToast,
  Divider,
  Heading,
  Flex,
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';
import {
  getChatFuelUserByPhone,
  getTemplateSelect,
  sendReactivacionChatFuelUsers,
} from '../../Services/ReactivacionChatFuelService';

import withPermisos from '../../HOC/withPermisos';
import RowPais from '../ListadoDatos/RowPais';

const ReactivacionChatfuel = () => {
  const [phoneInput, setPhoneInput] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [templates, setTemplates] = useState([]);

  const [pendingUser, setPendingUser] = useState(null);
  const [ventaOptions, setVentaOptions] = useState([]);
  const [selectedVenta, setSelectedVenta] = useState("");
  const [ventasChecked, setVentasChecked] = useState(false);
  const [ventasByUser, setVentasByUser] = useState({});

  const toast = useToast();

  const {
    isOpen: isNotFoundOpen,
    onOpen: onNotFoundOpen,
    onClose: onNotFoundClose,
  } = useDisclosure();
  const {
    isOpen: isConfirmOpen,
    onOpen: onConfirmOpen,
    onClose: onConfirmClose,
  } = useDisclosure();

  const mapVentasToOptions = (ventas) => {
  return ventas.map((venta) => {
    const value = venta.id || venta.idventa || venta.value || "";
    const label = venta.label || value;

    return {
      value: value.toString(),
      label: label.toString(),
    };
  });
};
  const handleSearch = async () => {
    if (!phoneInput.trim()) {
      toast({
        title: "Por favor, ingrese un número de celular.",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsSearching(true);
    const response = await getChatFuelUserByPhone(phoneInput);
    console.log(response);

    const payload = response?.data;
    const user = payload?.datoUsuario || null;

    if (!user) {
      onNotFoundOpen();
      setPendingUser(null);
      setVentaOptions([]);
      setSelectedVenta("");
      setVentasChecked(false);
      setIsSearching(false);
      return;
    }

    setPendingUser(user);

    const opts = mapVentasToOptions(payload?.datoVenta);
    setVentaOptions(opts);
    setSelectedVenta("");
    setVentasChecked(true);
    setIsSearching(false);
  };

  const handleAddPending = () => {
    if (!pendingUser) return;

    if (ventaOptions.length > 0 && !selectedVenta) {
      toast({
        title: "Seleccione un ID de venta",
        description: "Este celular tiene ventas asociadas. Elegí una antes de agregar.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const already = users.some(user => user.id === pendingUser.id);
    if (already) {
      toast({
        title: "Este teléfono ya ha sido agregado.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      setPendingUser(null);
      setPhoneInput("");
      setVentaOptions([]);
      setSelectedVenta("");
      setVentasChecked(false);
      return;
    }

    setUsers(prev => [...prev, pendingUser]);

    setVentasByUser(prev => ({
      ...prev,
      [pendingUser.id]: { selected: selectedVenta || null },
    }));


    setPendingUser(null);
    setPhoneInput("");
    setVentaOptions([]);
    setSelectedVenta("");
    setVentasChecked(false);
  };

  const handleRemoveUser = (userId) => {
    setUsers(users.filter((u) => u.id !== userId));
    setVentasByUser((prev) => {
      const clone = { ...prev };
      delete clone[userId];
      return clone;
    });
  };

  const handleSend = async () => {
    setIsSending(true);
    onConfirmClose();

    const usersIds = users.map((user) => user.id);
    const idsVenta = users.map((user) => ventasByUser[user.id]?.selected ?? null);

    const response = await sendReactivacionChatFuelUsers(
      usersIds, 
      selectedTemplate,
      idsVenta,
    );

    if (response?.status === "Success") {
      toast({
        title: response.message,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setUsers([]);
      setSelectedTemplate("");
      setPhoneInput("");
      setVentaOptions([]);
      setSelectedVenta("");
      setVentasChecked(false);
      setVentasByUser({});
      setPendingUser(null);
    } else {
      toast({
        title: response.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

  setIsSending(false);
};

  const getTemplates = async () => {
    const response = await getTemplateSelect();

    if (response.data) {
      setTemplates(response.data);
    }
  };

  useEffect(() => {
    getTemplates();
  }, []);

  return (
    <>
      <Heading color="gray.600" m={5} ml={0}>
        Envio Template
      </Heading>

      <Box
      p={{ base: 4, md: 8 }}
      maxWidth={{ base: "100%", md: "70%" }}
      margin="auto"
      >
        <VStack spacing={6} align="stretch">
          <Box
          p={6}
          borderWidth="1px"
          borderRadius="md"
          boxShadow="sm"
          backgroundColor="#ECF2F6"
          >
            <Flex justify="space-between" align="flex-end" wrap="wrap" gap={3}>
              <Flex gap={3} align="flex-end">
                <FormControl id="celular" maxW="280px">
                  <FormLabel fontSize="md">Celular *</FormLabel>
                  <Input
                    placeholder="Ingrese celular chatfuel"
                    value={phoneInput}
                    onChange={(e) => {
                      setPhoneInput(e.target.value.replace(/[^0-9]/g, ""));
                      setPendingUser(null);
                      setVentaOptions([]);
                      setSelectedVenta("");
                      setVentasChecked(false);
                    }}
                    backgroundColor="white"
                    type="tel"
                    size="md"
                  />
                </FormControl>

                <Button
                  onClick={handleSearch}
                  colorScheme="blue"
                  isLoading={isSearching}
                  size="sm"
                  mb="4px"
                  paddingX={{ base: 8, md: 6 }}
                >
                  Buscar
                </Button>

                <FormControl id="idventa" maxW="280px" isDisabled={!ventasChecked || ventaOptions.length === 0}>
                  <FormLabel fontSize="md">ID Venta</FormLabel>
                  <Select
                    placeholder={
                      isSearching
                        ? "Buscando..."
                        : (ventasChecked && ventaOptions.length === 0
                            ? "Este celular no tiene idventa"
                            : "Seleccione un idventa")
                    }
                    value={selectedVenta}
                    onChange={(e) => setSelectedVenta(e.target.value)}
                    isDisabled={!ventasChecked || ventaOptions.length === 0}
                    backgroundColor="white"
                    size="md"
                  >
                    {ventaOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.value} - {opt.label}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  onClick={handleAddPending}
                  colorScheme="green"
                  variant="solid"
                  size="md"
                  h="40px"
                  minW="140px"
                  fontSize="sm"
                  isDisabled={
                    !pendingUser || (ventaOptions.length > 0 && !selectedVenta)
                  }
                >
                  Agregar al listado
                </Button>
              </Flex>
              <Flex gap={3} align="flex-end">
                <FormControl
                id="template"
                isDisabled={users.length === 0}
                maxW="320px"
                >
                  <FormLabel fontSize="md">Template</FormLabel>
                  <Select
                    placeholder="Seleccione un template"
                    value={selectedTemplate}
                    onChange={(e) => setSelectedTemplate(e.target.value)}
                    isDisabled={users.length === 0}
                    backgroundColor="white"
                    size="md"
                  >
                    {templates.map((template) => (
                      <option key={template.value} value={template.value}>
                        {template.label}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  colorScheme="blue"
                  onClick={onConfirmOpen}
                  isDisabled={
                  users.length === 0 || !selectedTemplate || isSending
                }
                  isLoading={isSending}
                  size="sm"
                  mb="4px"
                  paddingX={{ base: 8, md: 6 }}
                >
                  Enviar
                </Button>
              </Flex>
            </Flex>
          </Box>

          <Divider />
          {users.length > 0 && (
            <Heading size="md" color="gray.600" m={5} ml={0}>
              Listado de celulares para enviar template
            </Heading>
          )}
          <HStack spacing={8} align="flex-start" width="100%">
            <Box flex="1">
              {users.length > 0 && (
                <Table
                variant="simple"
                borderWidth="1px"
                borderRadius="md"
                backgroundColor="#ECF2F6"
                >
                  <Thead backgroundColor="white">
                    <Tr>
                      <Th textAlign="center">PAIS</Th>
                      <Th textAlign="center">NOMBRE</Th>
                      <Th textAlign="center">NÚMERO DE WHATSAPP</Th>
                      <Th textAlign="center">EMAIL</Th>
                      <Th textAlign="center">ID SERVICIO</Th>
                      <Th textAlign="center">ACCIONES</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {users.map((user) => (
                      <Tr key={user.id}>
                        <Td textAlign="center">
                          <RowPais
                          nombrePais={user.nombrePais}
                          urlImage={user.banderaPais} 
                          />
                        </Td>
                        <Td textAlign="center">{user.userName}</Td>
                        <Td textAlign="center">{user.celular}</Td>
                        <Td textAlign="center">{user.email ?? "-"}</Td>
                        <Td textAlign="center">
                          {ventasByUser[user.id]?.selected || "-"}
                        </Td>
                        <Td textAlign="center">
                          <IconButton
                            aria-label="Eliminar usuario"
                            icon={<DeleteIcon />}
                            onClick={() => handleRemoveUser(user.id)}
                            size="sm"
                            colorScheme="red"
                            variant="ghost"
                          />
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              )}
            </Box>
          </HStack>
        </VStack>

        <Modal isOpen={isNotFoundOpen} onClose={onNotFoundClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Celular no encontrado</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>El celular ingresado no existe.</Text>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" onClick={onNotFoundClose}>
                OK
                </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal isOpen={isConfirmOpen} onClose={onConfirmClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmar envío</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>¿Está seguro que desea enviar el mensaje?</Text>
            </ModalBody>
            <ModalFooter>
              <Button variant="ghost" onClick={onConfirmClose}>
                Cancelar
                </Button>
              <Button colorScheme="blue" onClick={handleSend} ml={3}>
                Enviar
                </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default withPermisos(ReactivacionChatfuel, 512);